module.exports = __webpack_public_path__ + "static/media/shield-icon.322956c1.svg";